import type { ReactNode } from 'react';

export interface DsTab {
  id: string;
  label: string;
  count?: number;
}

interface DsTabNavProps {
  tabs: DsTab[];
  activeTab: string;
  onTabChange: (id: string) => void;
  maxWidth?: number;
  children?: ReactNode;
}

export function DsTabNav({ tabs, activeTab, onTabChange, maxWidth, children }: DsTabNavProps) {
  const innerStyle = maxWidth
    ? { maxWidth, margin: '0 auto', width: '100%', display: 'flex', alignItems: 'flex-end', gap: '1px', height: '100%', padding: '0 8px' } as const
    : undefined;

  const content = (
    <>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`ds-tab${activeTab === tab.id ? ' active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
          {tab.count != null && <span className="ds-tab-pill">{tab.count}</span>}
        </button>
      ))}
      {children && (
        <>
          <span className="ds-tab-spacer" />
          <div className="ds-tab-actions">{children}</div>
        </>
      )}
    </>
  );

  return (
    <div className="ds-tabnav" style={maxWidth ? { padding: 0 } : undefined}>
      {innerStyle ? <div style={innerStyle}>{content}</div> : content}
    </div>
  );
}
